<template>
  <div id="page-name" data-name="home">

    <section class="rev_slider_wrapper">
      <div id="rev_slider" class="rev_slider"  data-version="5.0">
        <ul>
          <!-- SLIDE  -->
          <li data-transition="fade">
            <!-- MAIN IMAGE -->
            <img src="images/slider/slide14.jpg" alt="" data-bgposition="center center" data-bgfit="cover">
            <!-- LAYER NR. 1 -->
            <div class="tp-caption tp-resizeme"
                 data-x="left"
                 data-y="310"
                 data-width="full"
                 data-transform_idle="o:1;"
                 data-transform_in="y:-50px;opacity:0;s:1500;e:Power3.easeOut;"
                 data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                 data-start="1600">
              <a href="#."
                 class="btn-common uppercase"
                 style="color:white;font-size: 20px;font-weight: bold;border:1px solid white!important;background:rgb(255, 16, 20);padding:18px;"
                 @click.prevent="submitAppShow = true"
              >
                  оставить заявку
              </a>
            </div>
          </li>
          <!-- SLIDE  -->
          <li data-transition="fade">
            <!-- MAIN IMAGE -->
            <img src="images/slider/slide11.jpg" alt="" data-bgposition="center center" data-bgfit="cover">
            <!-- LAYER NR. 1 -->
            <div class="tp-caption tp-resizeme"
                 data-x="800"
                 data-y="310"
                 data-width="full"
                 data-transform_idle="o:1;"
                 data-transform_in="y:-50px;opacity:0;s:1500;e:Power3.easeOut;"
                 data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                 data-start="1600">
              <a href="#."
                 class="btn-common uppercase"
                 style="color:white;font-size: 20px;font-weight: bold;border:1px solid white!important;background:rgb(255, 16, 20);padding:18px;"
                 @click.prevent="submitAppShow = true"
              >
                  оставить заявку
              </a>
            </div>
          </li>
          <!-- SLIDE  -->
          <li data-transition="fade">
            <!-- MAIN IMAGE -->
            <img src="images/slider/slide12.jpg" alt="" data-bgposition="center center" data-bgfit="cover">
            <!-- LAYER NR. 1 -->
            <div class="tp-caption tp-resizeme"
                 data-x="left"
                 data-y="250"
                 data-width="full"
                 data-transform_idle="o:1;"
                 data-transform_in="y:-50px;opacity:0;s:1500;e:Power3.easeOut;"
                 data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                 data-start="1600">
              <a href="#."
                 class="btn-common uppercase"
                 style="color:white;font-size: 20px;font-weight: bold;border:1px solid white!important;background:rgb(255, 16, 20);padding:18px;"
                 @click.prevent="submitAppShow = true"
              >
                  заказать сейчас
              </a>
            </div>
          </li>
        </ul>
      </div>
      <!-- END REVOLUTION SLIDER -->
    </section>
    <!--Three Box Products-->
    <section id="grid_box">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center minimase-margin-top-if-ipad" style="margin-top: 40px">
            <br><br>
            <h2 class="heading_space uppercase">наши цены. выгодно!
            </h2>
            <p class="">Приобретайте наши окна по выгодным ценам. Со скидкой 50%.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <a class="grid_box clearfix" href="#." style="cursor: default">
                <img src="images/windowtypes/1.jpg" alt="Product">
            </a>
              <div class="grid_body">
                <h3 class="text-center">Двухстворчатое окно</h3>
                <h2 class="text-center windowtypes-window-price" style="color: rgb(255, 16, 20)">3900 р.</h2>
              </div>
          </div>
          <div class="col-sm-4">
            <a class="grid_box clearfix" href="#." style="cursor: default">
                <img src="images/windowtypes/2.jpg" alt="Product">
            </a>
              <div class="grid_body">
                <h3 class="text-center">Трехстворчатое окно</h3>
                <h2 class="text-center windowtypes-window-price" style="color: rgb(255, 16, 20)">6700 р.</h2>
              </div>
          </div>
          <div class="col-sm-4">
            <a class="grid_box clearfix" href="#." style="cursor: default">
                <img src="images/windowtypes/3.jpg" alt="Product">
            </a>
              <div class="grid_body">
                <h3 class="text-center">Балконный блок</h3>
                <h2 class="text-center windowtypes-window-price" style="color: rgb(255, 16, 20)">9600 р.</h2>
              </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Delivery Service-->
    <section id="msg">
      <h3 class="hidden">hidden
      </h3>
      <div class="container">
          <br><br><br>
        <hr>
          <br>
        <div class="row">
          <div class="col-md-12 text-center" style="margin-top: 10px">
            <h2 class="heading_space uppercase" style="font-size: 40px">Почему мы<br><br>
            </h2>
            <p class="bottom_half hidden"></p>
          </div>
        </div>
        <div class="message">
          <div class="row">
            <div class="col-md-12">
                <div id="whywe">
                  <div class="item text-center">
                    <img src="images/whywe/garanty.png" alt="Brand Logo">
                      <div style="padding-top: 15px; color: #201f1f;">Гарантия</div>
                  </div>
                  <div class="item text-center">
                    <img src="images/whywe/opit.png" alt="Brand Logo">
                      <div style="padding-top: 15px; color: #201f1f;">Большой опыт</div>
                  </div>
                  <div class="item text-center">
                    <img src="images/whywe/halfprice.png" alt="Brand Logo">
                      <div style="padding-top: 15px; color: #201f1f;">Низкие цены</div>
                  </div>
                  <div class="item text-center">
                    <img src="images/whywe/mintime.png" alt="Brand Logo">
                      <div style="padding-top: 15px; color: #201f1f;">Минимальные сроки</div>
                  </div>
                  <div class="item text-center">
                    <img src="images/whywe/fullcomplex.png" alt="Brand Logo">
                      <div style="padding-top: 15px; color: #201f1f;">Полный комплекс услуг</div>
                  </div>
                </div>
            </div>
          </div>
        </div>
        <br>
        <hr>
      </div>
    </section>

    <!--NEW ARRIVALS-->
    <section id="arrivals" class="padding">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2 class="heading_space uppercase">наши работы
            </h2>            <p class="bottom_half">Посмотрите на наши реализованные проекты
          </p>

          </div>
        </div>
        <div class="row">
          <div id="fourCol-slider" class="owl-carousel">
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/1.jpg">
                    <img src="images/ourworks/mini/1.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Отделка балкона, стены откосы <br>на окне ламинирование пвх панели (не выгорают на солнце, устойчивы к повреждениям).
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/1.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/2.jpg">
                    <img src="images/ourworks/mini/2.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Внутренняя отделка лоджии «под ключ» (полы, линолеум плинтус, обшивка ламинированными ПВХ панелями, изготовление шкафа).
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/2.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/3.jpg">
                    <img src="images/ourworks/mini/3.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Внутренняя отделка лоджии «под ключ» (полы, линолеум плинтус, обшивка ламинированными ПВХ панелями, изготовление шкафа).
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/3.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/4.jpg">
                    <img src="images/ourworks/mini/4.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Внутренняя отделка лоджии «под ключ» (полы, линолеум плинтус, обшивка ламинированными ПВХ панелями, изготовление шкафа).
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/4.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/5.jpg">
                    <img src="images/ourworks/mini/5.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Остекление окон дачного дома<br><br><br><br>
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/5.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/6.jpg">
                    <img src="images/ourworks/mini/6.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Изготовление и монтаж окон в коттедж<br><br><br><br>
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/6.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/7.jpg">
                    <img src="images/ourworks/mini/7.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Установка окон и рольставни <br>в магазине<br><br><br>
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/7.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/8.jpg">
                    <img src="images/ourworks/mini/8.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Установка окон и рольставни <br>в магазине<br><br><br>
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/8.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/10.jpg">
                    <img src="images/ourworks/mini/10.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Усиление и Вынос Балкона, обшивка профлистом, остекление пвх и алюминиевыми конструкциями<br><br>
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/10.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/11.jpg">
                    <img src="images/ourworks/mini/11.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Отделка балкона, изготовление и установка полок из подоконной доски Danke (немецкий подоконник) обшивка пвх панелями, ленолиум плинтус.
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/11.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/12.jpg">
                    <img src="images/ourworks/mini/12.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Внутренняя отделка балкона «под ключ» Усиление каркаса, остекление пвх окнами, установка подоконника, обшивка декоративными пвх панелями).
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/12.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/13.jpg">
                    <img src="images/ourworks/mini/13.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Внутренняя отделка балкона «под ключ» Усиление каркаса, остекление пвх окнами, установка подоконника, обшивка декоративными пвх панелями).
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/13.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
            <div class="item">
              <div class="product_wrap">
                <div class="image">
                  <a class="fancybox" href="images/ourworks/full/14.jpg">
                    <img src="images/ourworks/mini/14.jpg" alt="Product" class="img-responsive">
                  </a>
                </div>
                <div class="product_desc">
                  <p>Внутренняя отделка балкона «под ключ» Усиление каркаса, остекление пвх окнами, установка подоконника, обшивка декоративными пвх панелями).
                  </p>
                  <span class="price">
<!--                    <i class="fa fa-gbp"></i>170.00-->
                  </span>
                  <a class="fancybox" href="images/ourworks/full/14.jpg" data-fancybox-group="gallery">
                    <i class="fa fa-search open">
                    </i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Slogan-->
    <section id="slogan">
      <br>
      <div class="container sloganBg">
        <div class="row">
          <div class="col-md-12">
            <div class="left">
              <h2 class="uppercase">
                <span style="color: #30ade7">с чего начать?
                </span> Закажите обратный звонок
              </h2>
              <p style="color:#0f0f0f">Оставьте свою заявку, и наш менеджер перезвонит Вам в ближайшее время
              </p>
            </div>
            <div class="right">
              <a href="#"
                 class="btn-common uppercase"
                 style="color:white;background:rgb(255, 16, 20);border:1px solid white!important;padding:14px"
                @click.prevent="backCallShow = true"
              >
                 Заказать обратный звонок
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--OUR BLOG-->
    <section id="blog" class="padding">
      <br>
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2 class="heading_space uppercase">О нас
            </h2>
            <p class="bottom_half">Наша компания вот уже более 9 лет выполняет изготовление и установку пластиковых и алюминиевых оконных конструкций по ценам от производителя. Мы изготавливаем пластиковые окна из лучших материалов, соответствующих принятым европейским стандартам качества. Оконные изделия компании «Окна Огонь» обеспечивают комфорт, надежность и высокое качество, что обеспечит Вашему дому тепло в любое время года. надежная звуко и теплоизоляция, защита от сквозняков и других негативных воздействий, которые сулит нам Российский климат.
            </p>
          </div>
          <div class="col-md-6">
            <div class="media blog_box">
              <div class="media-left">
                <a href="/aboutus">
                  <img class="media-object" src="images/aboutus/main1.jpg" alt="...">
                </a>
              </div>
              <div class="media-body">
                <h5 class="uppercase bottom30">
                  <a href="/aboutus">предоставим <br>гарантию и сервис
                  </a>
                </h5>
                <p class="bottom30" style="font-style: normal">Обратившись к нам за пластиковыми или алюминиевыми конструкциями, мы предоставим вам полностью гарантийное и сервисное обслуживание, а также ряд дополнительных бонусов.
                </p>
                <a href="/aboutus" class="readmor uppercase">узнать больше
                  <i class="fa fa-angle-double-right">
                  </i>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="media blog_box">
              <div class="media-left">
                <a href="/aboutus">
                  <img class="media-object" src="images/aboutus/main2.jpg" alt="...">
                </a>
              </div>
              <div class="media-body">
                <h5 class="uppercase bottom30">
                  <a href="/aboutus">Обеспечим <br>Надежность и комфорт
                  </a>
                </h5>
                <p class="bottom30" style="font-style: normal">Наши клиенты: это люди которые ценят качество уют и надежность, нам доверяют уже многие, к нам идут люди которые ценят своё время, свой комфорт в доме.
                </p>
                <a href="/aboutus" class="readmor uppercase">узнать больше
                  <i class="fa fa-angle-double-right">
                  </i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--BRANDS-->
    <section id="brands" class="padding_bottom">
      <h3 class="hidden">hidden
      </h3>
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center" style="margin-top: 10px">
            <h2 class="heading_space uppercase">Способы оплаты
            </h2>
            <p class="bottom_half">Вы можете оплатить свой заказ любым удобным для Вас способом
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div id="brand-slider" class="owl-carousel">
              <div class="item text-center">
                <img src="images/paymethods/cash.png" alt="Brand Logo">
                  <div>Наличные</div>
              </div>
              <div class="item text-center">
                <img src="images/paymethods/bill.png" alt="Brand Logo">
                  <div>По счету</div>
              </div>
              <div class="item text-center">
                <img src="images/paymethods/card.png" alt="Brand Logo">
                  <div>Карта</div>
              </div>
              <div class="item text-center">
                <img src="images/paymethods/transfer.png" alt="Brand Logo">
                  <div>Перевод</div>
              </div>
              <div class="item text-center">
                <img src="images/paymethods/installment.png" alt="Brand Logo">
                  <div>Рассрочка</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--NEWSLETER-->
    <section id="newsletter" class="padding">
      <div class="container">
        <div class="row">
          <div class="col-md-2">
          </div>
          <div class="col-md-8 text-center">
            <h2 class="heading_space uppercase" style="color:#DDD;font-size: 40px">оставить заявку на бесплатный замер
            </h2>
            <p class="bottom_half" style="color:white; font-size: 20px">Расчет Ваших окон за 5 минут
            </p>
              <a href="#."
                 class="btn-common uppercase"
                 style="color:white;background:rgb(255, 16, 20);border:1px solid white!important;padding:18px;font-size: 20px"
                 @click.prevent="submitAppShow = true"
              >Оставить заявку
              </a>
          </div>
          <div class="col-md-2">
          </div>
        </div>
      </div>
    </section>
    <!--Testinomial-->
    <section id="testinomial" class="padding" style="padding-bottom: 0px">
      <div class="container">
        <div class="row">
          <div class="col-md-1">
          </div>
          <div class="col-md-10">
            <div id="tstinomial-slider" class="owl-carousel">
              <div class="item text-center">
                <div class="testinomial_pic heading_space">
                  <img src="images/testinomial/333.png" alt="testinomial">
                  <h6 class="uppercase">Ирина
                  </h6>
                  <span class="uppercase">
                  </span>
                </div>
                <p>Новые окна сильно отличаются от тех что достались от застройщика, совсем тихо стало и не слышно с улицы шума, а главное из них совсем не дует! От старых окон занавески ходуном ходили и холодно было, менять пришлось в рассрочку, так как почти все за квартиру отдали. Фирму «ОкнаОгонь» посоветовали друзья, эта фирма как раз специализируется на хороших окнах и меняет аккуратно, мастера работают!К нам приезжал Максим, всё объяснил что нам нужно, что бы не пришлось переплачивать, итоговая цена порадовала, благодарим их за хорошую работу! А Сами новые окна добротные и тёплые, хорошая фирма.
                </p>
              </div>
              <div class="item text-center">
                <div class="testinomial_pic heading_space">
                  <img src="images/testinomial/111.png" alt="testinomial">
                  <h6 class="uppercase">Светлана
                  </h6>
                  <span class="uppercase">
                  </span>
                </div>
                <p>Спасибо компании и ребятам за качественный монтаж окон в моей квартире. Работа выполнена в срок. Изготовили за 6 дней . Приехали в 8-00 и начали монтаж трех окон. Вся работа порадовала все сделали под ключ. Редко встретишь людей которые не говорят, а делают качественно. Буду рекомендовать вас.
                </p>
              </div>
              <div class="item text-center">
                <div class="testinomial_pic heading_space">
                  <img src="images/testinomial/222.png" alt="testinomial">
                  <h6 class="uppercase">Татьяна
                  </h6>
                  <span class="uppercase">
                  </span>
                </div>
                <p>Огромное спасибо компании! От девочек-менеджеров до монтажников. Оперативный монтаж, профессиональное отношение, превосходный сервис и индивидуальный подход. Балкон получился просто замечательно. Ни в первый раз пользуюсь услугами "ОкнаОгонь!" Спасибо за хорошие цены, и скидки, на этот раз заказывала маме. Обязательно буду рекомендовать Вас и дальше своим друзьям и знакомым.
                </p>
              </div>
              <div class="item text-center">
                <div class="testinomial_pic heading_space">
                  <img src="images/testinomial/444.jpg" alt="testinomial">
                  <h6 class="uppercase">Людмила
                  </h6>
                  <span class="uppercase">
                  </span>
                </div>
                <p>Уже второй раз обращаюсь в эту компанию. Делали теще лоджию, теперь дома балкон и окна на кухне. Замерщики приезжают быстро и бесплатно. Довольна работой полностью. Аккуратно и чисто. Сделали скидку так как я льготник и пенсионерка. Спасибо менеджеру Ольге, и руководителю компании "ОкнаОгонь".
                </p>
              </div>
              <div class="item text-center">
                <div class="testinomial_pic heading_space">
                  <img src="images/testinomial/555.jpg" alt="testinomial">
                  <h6 class="uppercase">Сергей
                  </h6>
                  <span class="uppercase">
                  </span>
                </div>
                <p>Искал компанию в интернете, просмотрел много сайтов, рад, что остановил выбор на этой компании. По заявке перезвонили сразу же, грамотно проконсультировали. На замер приехали бесплатно, порекомендовали подходящий вариант. Цена порадовала. Доставили окна бережно и установили быстро и качественно. В общем, работой этой компании полностью удовлетворен.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-1">
          </div>
        </div>
      </div>
    </section>
    <section class="padding">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <h2 class="uppercase">Преимущества наших пластиковых окон
            </h2>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="availability text-center margin_top">
              <img src="images/ouradvance/1-award.png" class="ouradvance-icon">
              <h5 class="uppercase" style="color: black">Производство
              </h5>
                <span>Все окна ПВХ производятся на высокотехнологичном оборудовании с соблюдением ГОСТ РФ, что обеспечивает абсолютное качество характеристик пластиковых окон.<br><br></span>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="availability text-center margin_top">
              <img src="images/ouradvance/2-sale.png" class="ouradvance-icon">
              <h5 class="uppercase" style="color: black">Низкая цена
              </h5>
                <span>Мы сами являемся производителями оконных конструкций и можем позволить сделать для вас более выгодное предложение, нежели у большинства участников оконного рынка.<br><br></span>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="availability text-center margin_top">
              <img src="images/ouradvance/3-quality.png" class="ouradvance-icon">
              <h5 class="uppercase" style="color: black">Гарантия качества
              </h5>
                <span>Мы не экономим на оконных комплектующих и предлагаем своим клиентам такие пластиковые окна, какими они должны быть: без всяких удешевлений комплектующих (фурнитуры, профиля, армирования, стеклопакетов и т.д.).</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="availability text-center margin_top">
              <img src="images/ouradvance/4-window.png" class="ouradvance-icon">
              <h5 class="uppercase" style="color: black">У нас можно
              </h5>
                <span>Купить пластиковые окна и двери ПВХ. Алюминиевые конструкции заказать доставку и монтаж конструкций.<br><br><br></span>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="availability text-center margin_top">
              <img src="images/ouradvance/5-goal.png" class="ouradvance-icon">
              <h5 class="uppercase" style="color: black">Большой выбор
              </h5>
                <span>За 9 лет успешной работы мы произвели не одну тысячу изделий. Поэтому мы знаем, что вам предложить, как знаем и то, что вы сможете у нас найти именно то, что вас интересует!</span>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="availability text-center margin_top">
              <img src="images/ouradvance/6-window.png" class="ouradvance-icon">
              <h5 class="uppercase" style="color: black">Доставка и установка
              </h5>
                <span>Доставка и установка окон, остекление балконов и лоджий, обшивка и утепление балконов и лоджий, ремонт и регулировка окон.<br><br></span>
            </div>
          </div>
        </div>
      </div>
      <br>
    </section>

      <back-call :visibility="backCallShow" @closeDialog="backCallShow = false"/>
      <submit-app :visibility="submitAppShow" @closeDialog="submitAppShow = false"/>
  </div>
</template>

<script>
    import BackCall from './modals/BackCall.vue'
    import SubmitApp from "./modals/SubmitApp";
export default {
  components: {SubmitApp, BackCall },
  name: 'HelloWorld',
  props: {
    msg: String
  },
    data () {
      return {
        backCallShow: false,
        submitAppShow: false,
      }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #30ade7;
    }

    .ouradvance-icon {
        padding-bottom: 12px;
    }

    .windowtypes-window-price {
        padding-top: 10px;
    }

    .stock-image-wrap, .stock-image-wrap:hover {
        border: 6px solid #30ade7;
    }

    .stock-image-wrap .tag-btn {
        border-bottom: 10px solid transparent;
        border-top: 50px solid #30ade7;
        border-left: 15px solid #30ade7;
        border-right: 15px solid #30ade7;
    }

    .list-rectangle {
        list-style: none;
        margin: 0;
        padding: 60px 30px;
        font-size: 24px;
    }

    .list-rectangle > li {
        position: relative;
        display: block;
        margin-bottom: .99rem;
        padding: .325rem .825rem .325rem 1.325rem;
        color: #fff;
        background: #30ade7;
    }

    .list-rectangle > li:last-child {
        margin-bottom: 0;
    }

    .list-rectangle > li::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 0.5rem;
        background: #0060aa;
    }

    .whywe {
        border-left: 15px solid transparent;
        border-top: 15px solid #0060aa;
        border-right: 65px solid #0060aa;
        border-bottom: 15px solid #0060aa;
    }

    .message {
        border: 1px dotted #30ade7;
        border: none;
    }

    h2 {
        color: #0060aa;
    }

    #brand-slider img {
        /*transform: rotate(-12deg);*/
    }

    #brand-slider {
        border-bottom: none;
        border-top: none;
    }

    #arrivals .product_desc p {
        font-size: 14px;
        font-style: normal;
    }

    #arrivals .container-fluid {
        width: 80%;
    }

    @media screen and (max-width: 1366px) {
        #arrivals .container-fluid {
            width: 93%;
        }
    }

    #fourCol-slider .item {
        border: 1px solid #dee7ef;
        padding: 20px;
        border-radius: 3px;
        box-shadow: 0 4px 28px 0 rgba(0, 0, 0, .12);
        margin-bottom: 20px;
    }

    #whywe {
        display: flex;
        align-content: center;
        justify-content: space-between;
    }

    #whywe .item {
        /*float: left;*/
        text-align: center;
    }

    @media screen and (max-width: 1040px) {
        #whywe {
            flex-direction: column;
        }
        #whywe .item {
            padding-bottom: 40px;
        }
    }

</style>
